// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__g+JdH","closeIcon":"styles_closeIcon__ONz3m","isRtl":"styles_isRtl__EGoJS"};